import { StyleSheet } from 'react-native';
import { Link, spacing } from '@pletly/ui';

import { Spinner } from '@ui-kitten/components';
import { Props } from './types';
import { FileName } from '../FileName';
import { useFileLink } from './useFileLink';

export function FileLink({ url, filename, download, text, variant, style }: Props) {
	const { handleAction, loading, linkRef } = useFileLink({ url, filename, download });
	const name = text || filename;

	return (
		<Link to={url} onPress={handleAction} disabled={loading} style={[styles.root, style]}>
			{/* skipcq: JS-0739 */}
			<a role="button" ref={linkRef} style={styles.a}>
				<FileName name={name} variant={variant} />
			</a>

			{loading && <Spinner />}
		</Link>
	);
}

const styles = StyleSheet.create({
	root: {
		flexDirection: 'row',
		gap: spacing(),
		flexShrink: 1,
	},
	a: {
		display: 'flex',
		maxWidth: '100%',
	},
});
